import React from "react"
import styled from "@emotion/styled"

import "./dkLiveBlock.scss"

const dkLiveBlock = props => {
  const DkLiveImageBlock = styled.div`
    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-position: center;
      background-size: cover;
      background-image: url(${props.video_image.url});
    }
  `

  return (
    <div className="dk-live-block">
      <a className="dk-live-block__image" href={props.article_link}>
        <DkLiveImageBlock />
      </a>
      <div className="dk-live-block__content">
        <h2>{props.headline}</h2>
        <a href={props.article_link}>
          <p>{props.article_title}</p>
        </a>
      </div>
    </div>
  )
}

export default dkLiveBlock
